import { CurrencyPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { CallbackPipe } from './pipes/callback-filter.pipe';
import { EnumToArrayPipe } from './pipes/enum-to-array.pipe';
import { FallbackPipe } from './pipes/fallback.pipe';
import { ClientSearchPipe } from './pipes/filter.pipe';
import { HtmlToTextPipe } from './pipes/html-to-text.pipe';
import { ListObjectToStringDelimiterPipe } from './pipes/list-object-to-string-delimiter.pipe';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { RelativeTimePipe } from './pipes/relative-time.pipe';
import { SortByPipe } from './pipes/sort-by.pipe';

@NgModule({
    declarations: [
        SortByPipe,
        CallbackPipe,
        ClientSearchPipe,
        PhoneNumberPipe,
        EnumToArrayPipe,
        ListObjectToStringDelimiterPipe,
        RelativeTimePipe,
        HtmlToTextPipe,
        FallbackPipe
    ],
    imports: [],
    exports: [
        SortByPipe,
        CallbackPipe,
        ClientSearchPipe,
        PhoneNumberPipe,
        EnumToArrayPipe,
        ListObjectToStringDelimiterPipe,
        RelativeTimePipe,
        HtmlToTextPipe,
        FallbackPipe
    ],
    providers: [DatePipe, CurrencyPipe]
})
export class PipesModule {}
